const SMSNameSpace = 'sms';

const SMSActionTypes = Object.freeze({
    GetStatus: 'GetStatus',
    GetBalance: 'GetBalance',
    GetSenders: 'GetSenders',
    Send: 'Send',
});

const SMSMutationTypes = Object.freeze({
    SetStatus: 'SetStatus',
    SetBalance: 'SetBalance',
    SetSenders: 'SetSenders',
});

const SMSGetterTypes = Object.freeze({
    GetStatus: 'GetStatus',
    GetBalance: 'GetBalance',
    GetSenders: 'GetSenders',
});

export {
    SMSNameSpace,
    SMSActionTypes,
    SMSMutationTypes,
    SMSGetterTypes,
};